import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import PaymentMethodMobile from './PaymentMethodMobile';
const PaymentMethodsWrapper = styled.div `
  dl:last-child {
    border-bottom: 0;
  }
`;
const PaymentMethodsMobile = ({ paymentMethods, expandedId, errorMessage, handleClosePrompt, handleDeleteButton, handleConfirmDeletePaymentMethod, buttonRefs }) => {
    return (_jsx(PaymentMethodsWrapper, { children: paymentMethods.map((paymentMethod) => (_jsx(PaymentMethodMobile, { buttonRefs: buttonRefs, errorMessage: errorMessage, expandedId: expandedId, handleClosePrompt: handleClosePrompt, handleConfirmDeletePaymentMethod: handleConfirmDeletePaymentMethod, handleDeleteButton: handleDeleteButton, paymentMethod: paymentMethod }, paymentMethod.id))) }));
};
export default PaymentMethodsMobile;
